import { Lock } from 'lucide-react'

interface LockedCustomCodeActionProps {
  name?: string | null
  description?: string | null
}

// Embed shows a custom-code action's name and description only: never the code, nothing editable.
export const LockedCustomCodeAction = ({ name, description }: LockedCustomCodeActionProps) => (
  <div className="flex flex-col gap-3" data-testid="action-custom-code-locked">
    <div className="flex flex-col gap-1">
      <span className="text-s-600 text-secondary">Function name</span>
      <span className="text-p-400 text-primary break-all">{name || '-'}</span>
    </div>
    <div className="flex flex-col gap-1">
      <span className="text-s-600 text-secondary">Function description</span>
      <p className="text-p-400 text-primary whitespace-pre-wrap">{description || '-'}</p>
    </div>
    <div className="flex items-center gap-1.5 text-s-400 text-secondary">
      <Lock size={14} aria-hidden />
      Edit custom code in the Plivo console
    </div>
  </div>
)
